export default __webpack_public_path__ + "static/media/btn_apple_store.81306c70.png";